export var ScrollDirection;
(function (ScrollDirection) {
    ScrollDirection["Up"] = "up";
    ScrollDirection["Down"] = "down";
    ScrollDirection["None"] = "none";
})(ScrollDirection || (ScrollDirection = {}));
export default ScrollDirection;
